import { apiClient } from './apiClient';

const BASE = '/court-listener';

class CourtListenerService {
    /**
     * Search CourtListener for C&R documents matching the patient.
     * Returns ranked hits — does not import.
     */
    async search({ patientFirstName, patientLastName, jurisdictionState, dateOfInjury, court }) {
        return apiClient.post(`${BASE}/search`, {
            patientFirstName,
            patientLastName,
            jurisdictionState: jurisdictionState || undefined,
            dateOfInjury: dateOfInjury || undefined,
            court: court || undefined,
        });
    }

    /**
     * Import a hit into the document store.
     * Returns { document, duplicate, paywalled, message }.
     */
    async importDocument({ hit, claimId, patientId, subType = 'C_AND_R' }) {
        return apiClient.post(`${BASE}/import`, { hit, claimId, patientId, subType });
    }

    /**
     * Queue async AI summarization for a document.
     * Returns { workItem }.
     */
    async summarizeDocument(documentId, { promptId = 'c_and_r_summary', promptOverride } = {}) {
        return apiClient.post(`${BASE}/documents/${documentId}/summarize`, {
            promptId,
            promptOverride: promptOverride || null,
        });
    }

    /**
     * Save a user's manual edit to an existing AI summary.
     */
    async editSummary(documentId, editedText) {
        return apiClient.patch(`${BASE}/documents/${documentId}/summary`, { editedText });
    }

    /**
     * Get a prompt template by key (e.g. 'c_and_r_summary').
     */
    async getPromptTemplate(key) {
        return apiClient.get(`${BASE}/prompt-templates/${key}`);
    }

    /**
     * List all active prompt templates.
     */
    async listPromptTemplates() {
        return apiClient.get(`${BASE}/prompt-templates`);
    }

    /**
     * Update (or create) a prompt template.
     */
    async upsertPromptTemplate(key, updates) {
        return apiClient.put(`${BASE}/prompt-templates/${key}`, updates);
    }
}

export const courtListenerService = new CourtListenerService();
